import { useTranslate } from 'react-admin'

import type { SpecialEventType } from '@/data'
import type { MarpolAnnex } from '@/data/source'

export const useEventName = () => {
  const translate = useTranslate()
  return ({ type, marpolAnnex }: { type: SpecialEventType; marpolAnnex: MarpolAnnex | null }): string =>
    type === 'MARPOL' && marpolAnnex !== null ? translate(`enums.MarpolAnnex.${marpolAnnex}`) : translate(`enums.ScaleEventType.${type}`)
}
